import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import OtpInput from "@bachdgvn/vue-otp-input";
import {BootstrapVue} from 'bootstrap-vue'

import './assets/css/main.scss';

Vue.config.productionTip = false;

Vue.component("v-otp-input", OtpInput);
Vue.use(BootstrapVue);

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
